export const SPOTLIGHT_EDIT_BUTTON_KEY = 'edit-button';
export const SPOTLIGHT_SIDEBAR_HEADER_KEY = 'sidebar-header';
export const SPOTLIGHT_SIDEBAR_SEARCH_KEY = 'sidebar-search';
export const SPOTLIGHT_SIDEBAR_FIELD_KEY = 'sidebar-field';

export const BULK_EDIT_EDIT_BUTTON_SPOTLIGHTS_WIDTH = 382;
export const BULK_EDIT_SIDEBAR_SPOTLIGHTS_WIDTH = 448;

/* analytics event constants */
export const ANALYTICS_ACTION_SUBJECT = 'bulkMenu';

export const ANALYTICS_BULK_EDIT_ACTION_SUBJECT_ID = 'bulkEdit';
export const ANALYTICS_BULK_TRANSITION_ACTION_SUBJECT_ID = 'bulkTransition';

export const BULK_OPS_SELECTED_ISSUE_LIMIT = 1000;
